import React from 'react';

class NavigationMenuItemDividerView extends React.Component {
    render() {
        return (
            <li className="divider"></li>
        );
    }
}

export default NavigationMenuItemDividerView;
